import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TecidosCaptadosService } from './tecidos-captados.service';
import { TecidoList } from './tecido';

@Injectable({providedIn: 'root'})
export class TecidoStore {
    private readonly _tecido = new BehaviorSubject<TecidoList[]>([]);
    readonly tecido$ = this._tecido.asObservable();

    private readonly _relacionado = new BehaviorSubject<TecidoList[]>([]);
    readonly _relacionado$ = this._relacionado.asObservable();

    private readonly _productsPageIndex = new BehaviorSubject<string>("0");
    readonly productsPageIndex$ = this._productsPageIndex.asObservable();

    private readonly _productsSearch = new BehaviorSubject<string>("");
    readonly productsSearch$ = this._productsSearch.asObservable();
    
    private readonly _productsPageSize = new BehaviorSubject<string>("");
    readonly productsPageSize$ = this._productsPageSize.asObservable();

    private readonly _productsLenght = new BehaviorSubject<number>(0);
    readonly productsLenght$ = this._productsLenght.asObservable();


    constructor(private tecidoService:TecidosCaptadosService){}

    initState(pageIndex:string,pageSize:string,search:string,lenght: number){
        if(this.pageSearch == ""){
            this.pageSearch = search;
        }
       
        if(this.tecidos.length === 0){
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.tecidoService.findAll(this.pageSize,this.pageIndex,this.pageSearch).subscribe( res => {
                this.pageLenght = res.total;
                this.tecidos = res.results;
            })
        }
    }


    get tecidos(): TecidoList[]{
        return this._tecido.getValue();
    }

    set tecidos(val: TecidoList[]) {
        this._tecido.next(val);
    }


    get relacionado(): TecidoList[]{
        return this._relacionado.getValue();
    }

    set relacionado(val: TecidoList[]) {
        this._relacionado.next(val);
    }

    get pageIndex():string{
        return this._productsPageIndex.getValue();
    }

    set pageSize(page:string){
        this._productsPageSize.next(page);
    }

    get pageSize():string{
        return this._productsPageSize.getValue();
    }

    set pageIndex(page:string){
        this._productsPageIndex.next(page);
    }

    get pageLenght():any{
        return this._productsLenght.getValue();
    }

    set pageLenght(lenght:any){
        this._productsLenght.next(lenght);
    }

    get pageSearch():string{
        return this._productsSearch.getValue();
    }

    set pageSearch(busca: string){
        this._productsSearch.next(busca);
    }

    addTecido(tecido: TecidoList) {
        if(this.tecidos.length >= parseInt(this.pageSize)){
            this.tecidos.pop();
        }
        this.tecidos = [
            tecido,
          ...this.tecidos, 
        ];
         this.pageLenght = parseInt(this.pageLenght) + 1;
    }

    updateTecido(product: TecidoList){
        this.tecidos.forEach( (element,index) => {
            if(element.codigo == product.codigo){
                this.tecidos[index] = product
            }
        })
    }
    
    // removeProduct(codigo:string){
    //     this.coletores = this.coletores.filter(product => product.codigo !== codigo);
    //     this.pageLenght = this.pageLenght - 1;
    // }

}